import { useState, useRef, useEffect, ReactNode } from "react";

interface ProjectDescriptionProps {
  description: ReactNode | string;
  className?: string;
}

export const ProjectDescription = ({ description, className }: ProjectDescriptionProps) => {
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(true);
  const descriptionRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (descriptionRef.current) {
      const isOverflowing =
        descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight;
      setShowReadMore(isOverflowing);
    }
  }, [description]);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div
      className={`min-h-32 overflow-hidden rounded-lg bg-white shadow-md ${className} `}
      style={{ maxHeight: expanded ? "none" : "100%" }}
    >
      <h3 className="p-4 text-lg font-medium">Project Description</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4">
        <div
          ref={descriptionRef}
          className={`text-sm ${expanded ? "h-auto" : "h-32 overflow-hidden"}`}
          style={{ maxHeight: expanded ? undefined : 64 }}
        >
          {description}
        </div>
        {showReadMore && (
          <button
            onClick={toggleExpanded}
            className="text-sm font-medium text-purple-800 hover:text-purple-900"
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    </div>
  );
};
